/* Copyright Verge Technologies 2018
 * @file pagination.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description component responsible for pagination
 */

// Modules
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// const createList = (props) => {
//   const list = [];
//   for (let i = 0; i < props.pages; i++) {
//     if (i >= (props.pages - 1 === props.page ? props.page - 2 : props.page - 1) && i <= ([1, 2].includes(props.page) ? 3 : props.page + 1)) {
//       list.push(
//         <li key={i}>
//           <a onClick={() => { props.updatePage(i); setTimeout(() => window.scrollTo(0, 0), 1) }} className={props.page === i ? 'active' : ''}>{i+1}</a>
//         </li>
//       );
//     }
//   }
//   return list;
// };

// const createList = (props) => {
//   const list = [];
//   for (let i = 0; i < props.pages; i++) {
//     //if (i >= (props.pages - 1 === props.page ? props.page - 2 : props.page - 1) && i <= ([1, 2].includes(props.page) ? 3 : props.page + 1)) {
//     var shouldshow = true;
//     //if(i<props.page-1 && props.page>=2) shouldshow=false;
//     //if(i>props.page+2 && props.page<props.pages-2) shouldshow=false;

//     if(i==0 && props.page>=2) shouldshow=false;
//     if(i==1 && props.page>=3) shouldshow=false;
//     if(i==2 && props.page>=4) shouldshow=false;
//     if(i==3 && props.page>=5) shouldshow=false;


//     if(i>2 && props.page==0) shouldshow=false;
//     if(i>3 && props.page==1) shouldshow=false;
//     if(i>4 && props.page==1) shouldshow=false;
//     if(i>5 && props.page==1) shouldshow=false;
    

//     if(shouldshow){      
//       list.push(
//         <li key={i}>
//           <a onClick={() => { props.updatePage(i); setTimeout(() => window.scrollTo(0, 0), 1) }} className={props.page === i ? 'active' : ''}>{i+1}</a>
//         </li>
//       );
//     }
//     //}
//   }
//   return list;
// };

const createList = (props) => {
  const list = [];
  var slotsused = 0;
  var mid = props.page;
  if(props.page==0) mid=1;
  if(props.page==2) mid=1;
  if(props.page==props.pages-1) mid=props.pages-1-1;
  if(props.page==props.pages-1-1) mid=props.pages-1-1;

  for (let i = mid-1; i <= mid+1; i++) {
    //if (i >= (props.pages - 1 === props.page ? props.page - 2 : props.page - 1) && i <= ([1, 2].includes(props.page) ? 3 : props.page + 1)) {
    var shouldshow = true;
    if(i<0) shouldshow=false;
    if(i>=props.pages) shouldshow=false;

    if(shouldshow && slotsused<3){
      slotsused++;      
      list.push(
        <li key={i}>
          <a onClick={() => { props.updatePage(i); setTimeout(() => window.scrollTo(0, 0), 1) }} className={props.page === i ? 'active' : ''}>{i+1}</a>
        </li>
      );
    }
    //}
  }
  return list;
};


const disabledCheck = (side, props) => {
  if (props.pages === 1) {
    return true;
  }
  if (side === 'left' && props.page === 0) {
    return true;
  }
  if (side === 'right' && props.page+1  === props.pages) {
    return true;
  }
  return false;
};

const Pagination = (props) => {
  return (
    <div className="pagination">
      <a onClick={() => { props.updatePage(props.page - 1); setTimeout(() => window.scrollTo(0, 0), 1) }} className={disabledCheck('left', props) ? 'sides left disabled' : 'sides left'}>
        <svg viewBox="0 0 12.074 12.074">
          <path
            fill={disabledCheck('left', props) ? '#000000' : '#004DA9'}
            d="M0,8.538V1.708A1.731,1.731,0,0,1,1.708,0h6.83V1.708H2.277a.486.486,0,0,0-.5.5V8.538H0Z"
            transform="translate(0 6.037) rotate(-45)"
          />
        </svg>
        <span>Previous</span>
      </a>
      <ul className="pages">
        { (props.page) >= 3 && (
          <Fragment>
            <li>
              <a onClick={() => { props.updatePage(0); setTimeout(() => window.scrollTo(0, 0), 1) }}>1</a>
            </li>
            <li>
              ...
            </li>
          </Fragment>)
        }
        {createList(props).map((item) => {
          return item;
        })}
        { (props.page) < props.pages - 2 && (
          <Fragment>
            <li>
              ...
            </li>
            <li>
              <a onClick={() => { props.updatePage(props.pages - 1); setTimeout(() => window.scrollTo(0, 0), 1) }}>{props.pages}</a>
            </li>
          </Fragment>)
        }
      </ul>
      <a onClick={() => { props.updatePage(props.page+1); setTimeout(() => window.scrollTo(0, 0), 1) }} className={disabledCheck('right', props) ? 'sides right disabled' : 'sides right'}>
        <span>Next</span>
        <svg viewBox="0 0 12.074 12.074">
          <path
            fill={disabledCheck('right', props) ? '#000000' : '#004DA9'}
            d="M0,8.538V1.708A1.731,1.731,0,0,1,1.708,0h6.83V1.708H2.277a.486.486,0,0,0-.5.5V8.538H0Z"
            transform="translate(12.074 6.037) rotate(135)"
          />
        </svg>
      </a>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/pagination.js